import { z } from '@uturn/portal/zod';

export const passwordResetRequestSchema = z.object({
	email: z.string().trim().email(),
});

export type PasswordResetRequestFormValues = z.infer<
	typeof passwordResetRequestSchema
>;
